__turbopack_context__.v({
  "chevron": "Dropdown-module__XSaKsG__chevron",
  "chevron__open": "Dropdown-module__XSaKsG__chevron__open",
  "dropdown": "Dropdown-module__XSaKsG__dropdown",
  "label": "Dropdown-module__XSaKsG__label",
  "menu": "Dropdown-module__XSaKsG__menu",
  "noOptions": "Dropdown-module__XSaKsG__noOptions",
  "option": "Dropdown-module__XSaKsG__option",
  "option__disabled": "Dropdown-module__XSaKsG__option__disabled",
  "option__selected": "Dropdown-module__XSaKsG__option__selected",
  "options": "Dropdown-module__XSaKsG__options",
  "search": "Dropdown-module__XSaKsG__search",
  "searchInput": "Dropdown-module__XSaKsG__searchInput",
  "trigger": "Dropdown-module__XSaKsG__trigger",
  "triggerText": "Dropdown-module__XSaKsG__triggerText",
  "trigger__open": "Dropdown-module__XSaKsG__trigger__open",
});
